import React, { useState } from 'react';
import { Input } from '@mm/components';
import styles from './ClarifyWebsiteTraffic.module.css';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { SEMRushWebsiteTrafficModel } from '@mm/state/model/SEMRushWebsiteTrafficModel';

export const ClarifyWebsiteTraffic = ({
  website,
  totalTrafficRef,
  openModalState,
  setOpenModal,
}: {
  website: string;
  totalTrafficRef: React.MutableRefObject<SEMRushWebsiteTrafficModel>;
  setOpenModal: React.Dispatch<
    React.SetStateAction<{
      editURL: boolean;
      instachamp: boolean;
      traffic: boolean;
      signup: boolean;
    }>
  >;
  openModalState: {
    editURL: boolean;
    instachamp: boolean;
    traffic: boolean;
    signup: boolean;
  };
}) => {
  const [organicTraffic, setOrganicTraffic] = useState<string | undefined>(
    undefined,
  );
  const [paidTraffic, setPaidTraffic] = useState<string | undefined>(undefined);

  const setTraffic = (isOrganic: boolean, traffic: string) => {
    if (isOrganic) {
      setOrganicTraffic(traffic);
      totalTrafficRef.current = {
        trafficTypes: {
          organic: Number(traffic),
          paid: totalTrafficRef.current.trafficTypes?.paid,
        },
      };
    } else {
      setPaidTraffic(traffic);
      totalTrafficRef.current = {
        trafficTypes: {
          organic: totalTrafficRef.current.trafficTypes?.organic,
          paid: Number(traffic),
        },
      };
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.heading}>We need a little more information </div>
        <div className={styles.subheader}>
          To determine if we are able to, and how many leads we can capture from
          the web traffic for{' '}
          <span className={styles.subheader}>{website}</span>
        </div>
      </div>

      <div className={styles.form}>
        <div className={styles.formBlock}>
          <div className={styles.title}>
            Your organic traffic
            <span className={styles.note}>(last 30 days)</span>
          </div>
          <Input
            type="text"
            css={{ container: styles.input }}
            placeholder="5,000"
            value={organicTraffic}
            onChange={e => {
              const number = e.target.value.match(/[0-9]+/)?.toString();
              if (number) {
                setTraffic(true, number);
              }
            }}
          />
        </div>
        <div className={styles.formBlock}>
          <div className={styles.title}>
            Your paid traffic
            <span className={styles.note}>(last 30 days)</span>
          </div>
          <Input
            type="text"
            css={{ container: styles.input }}
            placeholder="1,000"
            value={paidTraffic}
            onChange={e => {
              const number = e.target.value.match(/[0-9]+/)?.toString();
              if (number) {
                setTraffic(false, number);
              }
            }}
          />
        </div>
      </div>

      <div className={styles.actions}>
        <PrimaryButton
          className={styles.button}
          disabled={!organicTraffic || !paidTraffic}
          onClick={() =>
            setOpenModal({
              ...openModalState,
              traffic: false,
              instachamp: Number(organicTraffic) + Number(paidTraffic) < 1000,
            })
          }
        >
          Get my report now
        </PrimaryButton>
        <div
          className={styles.subheader}
          onClick={() =>
            setOpenModal({
              ...openModalState,
              traffic: false,
              instachamp: true,
            })
          }
        >
          Don’t have this information?
        </div>
      </div>
    </div>
  );
};
